import React from 'react';
import imgVector from '../../assets/sections/a114ac1575e0303158ba016f7b07b5da56979d66.svg';
import imgVector1 from '../../assets/sections/8e85af30cecd69a3f52727d6eb0b9a9496a8be89.svg';
import imgImage7 from '../../assets/sections/00d14b12320dbdbd6d51dff62ccdcdf99257c5cf.png';
import imgImage38 from '../../assets/sections/572cec5304ba148bbfcee1651703f14a9ecb6c1a.png';
import imgPolygon14 from '../../assets/sections/e58130c25971f643296fba40c05b17147a6e690f.png';
import imgImage33 from '../../assets/sections/6e09cb989edaa01a74638f49906d5aadb3e25241.png';
import imgImage62 from '../../assets/sections/9e3a7e281e1bfc182a95fe9a8c7faae8ae6e0549.png';
import imgSpeaker1 from '../../assets/sections/f2bc232ed718309590f599c4d66a6ef81ca18d7f.png';
import imgSpeaker2 from '../../assets/sections/287dbec5f7406a67d71d2f2ec11b62a528861744.png';
import imgEllipse2 from '../../assets/sections/d068f20e9b14a6b4fc50e664c1c4a93eacf9cfa2.svg';
import imgImage32 from '../../assets/sections/602ab1fe3fa2f276ba69f70e1e3afa15f2d96277.svg';
import imgGroup19 from '../../assets/sections/6d3e166da482b6f5d4d33c5d5b362da7d2c7cdaa.svg';
import imgImage61 from '../../assets/sections/3944dcb7b3a1b1ba867f4811fec9cabc223d5781.svg';
import imgMaskSpeaker from '../../assets/sections/cf46408ae93ab82fa58984cdce0f46ad2d0bd091.svg';


function BoldMapLocationMapPoint({ className }) {
  return (
    <div className={className || "overflow-clip relative size-[32px]"} data-node-id="2007:71">
      <div className="absolute inset-[8.33%_16.67%]" data-node-id="2007:72">
        <img alt="" className="absolute block max-w-none size-full" src={imgVector} />
      </div>
    </div>
  );
}

function BoldTimeAlarm({ className }) {
  return (
    <div className={className || "overflow-clip relative size-[32px]"} data-node-id="2007:84">
      <div className="absolute inset-[8.33%_12.5%]" data-node-id="2007:85">
        <img alt="" className="absolute block max-w-none size-full" src={imgVector1} />
      </div>
    </div>
  );
}

export default function Webinar() {
  return (
    <div className="relative w-[1920px] h-[1080px]" data-node-id="2007:232">
      {/* Background */}
      <div className="absolute h-[1082px] left-0 top-0 w-[1920px]" data-name="image 7" data-node-id="2007:233">
        <div aria-hidden="true" className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 overflow-hidden">
            <img alt="" className="absolute h-full left-[-43.78%] max-w-none top-0 w-[143.95%]" src={imgImage7} />
          </div>
          <div className="absolute bg-[#002e2a] inset-0" />
        </div>
      </div>
      <div className="absolute h-[1492px] left-[-244px] top-0 w-[2387px]" data-name="image 38" data-node-id="2007:234">
        <div aria-hidden="true" className="absolute inset-0 pointer-events-none">
          <img alt="" className="absolute max-w-none object-cover size-full" src={imgImage38} />
          <div className="absolute bg-gradient-to-b from-[#002e2a] inset-0 to-[rgba(0,46,42,0.5)]" />
        </div>
      </div>
      {/* Ellipse glow */}
      <div className="absolute h-[353px] left-[32px] top-[430px] w-[750px]" data-node-id="2007:235">
        <div className="absolute inset-[-139.94%_-65.87%]">
          <img alt="" className="block max-w-none size-full" src={imgEllipse2} />
        </div>
      </div>
      {/* CTA Button */}
      <div className="cursor-pointer absolute bg-[#01b04f] content-stretch flex h-[80px] items-center justify-center left-[844px] px-[19px] py-[14px] rounded-[16px] shadow-[0px_24px_84px_0px_rgba(0,0,0,0.1)] top-[722px] w-[226px]" data-name="Discount container" data-node-id="2007:236"
        onClick={() => { window.open("https://forms.gle/6gMBj3K5kRQxL5qL9", "_blank") }}
      >
        <p className="font-['Alexandria',sans-serif] font-bold leading-[1.5] relative shrink-0 text-[21px] text-center text-white whitespace-nowrap" data-node-id="2007:237">
          KHÁM PHÁ NGAY
        </p>
      </div>
      {/* Time & Location */}
      <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[844px] top-[568px] w-[663px]" data-node-id="2007:238">
        <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full" data-node-id="2007:239">
          <BoldTimeAlarm className="overflow-clip relative shrink-0 size-[32px]" />
          <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[32px] text-white whitespace-nowrap" data-node-id="2007:241">
            Thời gian: 19h30 - 21h30, Thứ 3 ngày 07.04.2026
          </p>
        </div>
        <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full" data-node-id="2007:242">
          <BoldMapLocationMapPoint className="overflow-clip relative shrink-0 size-[32px]" />
          <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[32px] text-white whitespace-nowrap" data-node-id="2007:244">
            Online qua Zoom
          </p>
        </div>
      </div>
      {/* Title */}
      <div className="absolute content-stretch flex flex-col gap-[26px] items-start left-[844px] top-[277px] w-[942px]" data-node-id="2007:245">
        <p className="font-['Alexandria',sans-serif] font-normal leading-[normal] opacity-50 relative shrink-0 text-[32px] text-white" data-node-id="2007:246">
          WEBINAR
        </p>
        <div className="font-['Alexandria',sans-serif] font-bold leading-[0] relative shrink-0 text-[#e9fffa] text-[56px] uppercase w-[1024px] whitespace-pre-wrap" data-node-id="2007:247">
          <p className="leading-[79.571px] mb-0">{`Hải Phòng - Xu hướng `}</p>
          <p className="leading-[79.571px]">và cơ hội việc làm tương lai</p>
        </div>
      </div>

      {/* === SPEAKERS ROW 1 === */}
      {/* Speaker 1: Ms. Đặng Thị Huệ (Uni) */}
      <div className="absolute contents left-[142px] top-[185px]" data-node-id="2007:248">
        <div className="absolute h-[210px] left-[150px] top-[259px] w-[246px]" data-node-id="2007:249">
          <img alt="" className="absolute block max-w-none size-full" height="210" src={imgPolygon14} width="246" />
        </div>
        <div className="absolute h-[349px] left-[153px] top-[211px] w-[259px]" data-name="image 32" data-node-id="2007:252"
          style={{ maskImage: `url('${imgImage32}')`, WebkitMaskImage: `url('${imgImage32}')`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: '5.729px -26px', WebkitMaskPosition: '5.729px -26px', maskSize: '248.541px 304px', WebkitMaskSize: '248.541px 304px' }}>
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <img alt="" className="absolute h-[119.67%] left-[-7.12%] max-w-none top-[-19.7%] w-[113.94%]" src={imgImage33} />
          </div>
        </div>
        <div className="absolute h-0 left-[179.92px] top-[467.69px] w-[192.334px]" data-node-id="2007:253">
          <div className="absolute inset-[-31.34px_-16.29%]">
            <img alt="" className="block max-w-none size-full" src={imgGroup19} />
          </div>
        </div>
        <div className="absolute content-stretch flex flex-col gap-[6.483px] items-center justify-center left-[142px] px-[22.691px] py-[12.966px] rounded-[8.644px] shadow-[0px_32.416px_56.187px_0px_rgba(0,0,0,0.05)] top-[468.69px] w-[261.488px]" data-node-id="2007:256">
          <div aria-hidden="true" className="absolute bg-[#1a433f] inset-0 pointer-events-none rounded-[8.644px]" />
          <p className="font-['Alexandria',sans-serif] font-bold leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[15.127px] uppercase whitespace-nowrap" data-node-id="2007:257">
            Ms. Đặng Thị Huệ (Uni)
          </p>
          <p className="font-['Alexandria',sans-serif] font-medium leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[12.966px] whitespace-nowrap" data-node-id="2007:258">
            Trưởng phòng TA Minimart
          </p>
          <p className="font-['Alexandria',sans-serif] font-bold leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[12.966px] whitespace-nowrap" data-node-id="2007:259">
            Wincommerce (Masan Group)
          </p>
          <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_54.026px_0px_rgba(0,177,79,0.1)]" />
        </div>
      </div>

      {/* Speaker 2: Ms. Trang Vũ */}
      <div className="absolute contents left-[484px] top-[185px]" data-node-id="2007:272">
        <div className="absolute h-[210px] left-[492px] top-[259px] w-[246px]" data-node-id="2007:273">
          <img alt="" className="absolute block max-w-none size-full" height="210" src={imgPolygon14} width="246" />
        </div>
        <div className="absolute h-[310px] left-[484px] top-[198px] w-[261px]" data-name="image 61" data-node-id="2007:276"
          style={{ maskImage: `url('${imgImage61}')`, WebkitMaskImage: `url('${imgImage61}')`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: '16.729px -13px', WebkitMaskPosition: '16.729px -13px', maskSize: '248.541px 304px', WebkitMaskSize: '248.541px 304px' }}>
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <img alt="" className="absolute h-[113.36%] left-[-16.48%] max-w-none top-[-13.29%] w-[117.62%]" src={imgImage62} />
          </div>
        </div>
        <div className="absolute h-0 left-[521.92px] top-[467.69px] w-[192.334px]" data-node-id="2007:277">
          <div className="absolute inset-[-31.34px_-16.29%]">
            <img alt="" className="block max-w-none size-full" src={imgGroup19} />
          </div>
        </div>
        <div className="absolute content-stretch flex flex-col gap-[6.483px] items-center justify-center left-[484px] px-[22.691px] py-[12.966px] rounded-[8.644px] shadow-[0px_32.416px_56.187px_0px_rgba(0,0,0,0.05)] top-[468.69px] w-[261.488px]" data-node-id="2007:280">
          <div aria-hidden="true" className="absolute bg-[#1a433f] inset-0 pointer-events-none rounded-[8.644px]" />
          <p className="font-['Alexandria',sans-serif] font-bold leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[15.127px] uppercase whitespace-nowrap" data-node-id="2007:281">
            Ms. Trang Vũ
          </p>
          <p className="font-['Alexandria',sans-serif] font-medium leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[12.966px] whitespace-nowrap" data-node-id="2007:282">
            Senior Talent Acquisition
          </p>
          <p className="font-['Alexandria',sans-serif] font-bold leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[12.966px] whitespace-nowrap" data-node-id="2007:283">
            Ngân hàng Bán lẻ MSB
          </p>
          <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_54.026px_0px_rgba(0,177,79,0.1)]" />
        </div>
      </div>

      {/* === SPEAKERS ROW 2 === */}
      {/* Speaker 3: (Host) Ms. Thái Trần */}
      <div className="absolute contents left-[143px] top-[599px]" data-node-id="2007:296">
        <div className="absolute h-[210px] left-[151px] top-[673px] w-[246px]" data-node-id="2007:297">
          <img alt="" className="absolute block max-w-none size-full" height="210" src={imgPolygon14} width="246" />
        </div>
        <div className="absolute h-[435px] left-[122px] top-[574px] w-[297px]" data-name="speaker mask 1" data-node-id="2007:300"
          style={{ maskImage: `url('${imgMaskSpeaker}')`, WebkitMaskImage: `url('${imgMaskSpeaker}')`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: '37.729px 25px', WebkitMaskPosition: '37.729px 25px', maskSize: '248.541px 304px', WebkitMaskSize: '248.541px 304px' }}>
          <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgSpeaker1} />
        </div>
        <div className="absolute h-0 left-[180.92px] top-[881.69px] w-[192.334px]" data-node-id="2007:301">
          <div className="absolute inset-[-31.34px_-16.29%]">
            <img alt="" className="block max-w-none size-full" src={imgGroup19} />
          </div>
        </div>
        <div className="absolute content-stretch flex flex-col gap-[6.483px] items-center justify-center left-[143px] px-[22.691px] py-[12.966px] rounded-[8.644px] shadow-[0px_32.416px_56.187px_0px_rgba(0,0,0,0.05)] top-[882.69px] w-[261.488px]" data-node-id="2007:304">
          <div aria-hidden="true" className="absolute bg-[#1a433f] inset-0 pointer-events-none rounded-[8.644px]" />
          <p className="font-['Alexandria',sans-serif] font-bold leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[15.127px] uppercase whitespace-nowrap" data-node-id="2007:305">
            (Host) Ms. Thái Trần
          </p>
          <p className="font-['Alexandria',sans-serif] font-medium leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[12.966px] whitespace-nowrap" data-node-id="2007:306">
            Driven HR Professional
          </p>
          <p className="font-['Alexandria',sans-serif] font-bold leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[12.966px] whitespace-nowrap" data-node-id="2007:307">
            Hai Phong
          </p>
          <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_54.026px_0px_rgba(0,177,79,0.1)]" />
        </div>
      </div>

      {/* Speaker 4: Mr. Mai Văn Sùng */}
      <div className="absolute contents left-[485px] top-[599px]" data-node-id="2007:320">
        <div className="absolute h-[210px] left-[493px] top-[673px] w-[246px]" data-node-id="2007:321">
          <img alt="" className="absolute block max-w-none size-full" height="210" src={imgPolygon14} width="246" />
        </div>
        <div className="absolute h-[435px] left-[474px] top-[574px] w-[297px]" data-name="speaker mask 2" data-node-id="2007:324"
          style={{ maskImage: `url('${imgMaskSpeaker}')`, WebkitMaskImage: `url('${imgMaskSpeaker}')`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: '27.729px 25px', WebkitMaskPosition: '27.729px 25px', maskSize: '248.541px 304px', WebkitMaskSize: '248.541px 304px' }}>
          <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgSpeaker2} />
        </div>
        <div className="absolute h-0 left-[522.92px] top-[881.69px] w-[192.334px]" data-node-id="2007:325">
          <div className="absolute inset-[-31.34px_-16.29%]">
            <img alt="" className="block max-w-none size-full" src={imgGroup19} />
          </div>
        </div>
        <div className="absolute content-stretch flex flex-col gap-[6.483px] items-center justify-center left-[485px] px-[22.691px] py-[12.966px] rounded-[8.644px] shadow-[0px_32.416px_56.187px_0px_rgba(0,0,0,0.05)] top-[882.69px] w-[261.488px]" data-node-id="2007:328">
          <div aria-hidden="true" className="absolute bg-[#1a433f] inset-0 pointer-events-none rounded-[8.644px]" />
          <p className="font-['Alexandria',sans-serif] font-bold leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[15.127px] uppercase whitespace-nowrap" data-node-id="2007:329">
            Mr. Mai Văn Sùng
          </p>
          <p className="font-['Alexandria',sans-serif] font-medium leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[12.966px] whitespace-nowrap" data-node-id="2007:330">
            Human Resources Management
          </p>
          <p className="font-['Alexandria',sans-serif] font-bold leading-[19.449px] relative shrink-0 text-[#d4f8eb] text-[12.966px] whitespace-nowrap" data-node-id="2007:331">
            LG Innotek
          </p>
          <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_54.026px_0px_rgba(0,177,79,0.1)]" />
        </div>
      </div>
    </div>
  );
}
